<template>
  <div id="app">
    <router-view />
    <!-- <el-backtop :right="10" :visibility-height="200"></el-backtop> -->
  </div>
</template>

<script>
export default {
  watch: {},
  name: "App",
  methods: {},
};
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"]{
  -moz-appearance: textfield;
}
</style>